import React from "react"
import styled from "styled-components"

import { Color, Spacing, Typography } from "@persona-id/design-tokens"
import { ChatIcon } from "@persona-id/design-tokens/icons/16px"

const NavigationLeftHelp = () => {
  return (
    <NavigationLeftHelpRow>
      <ChatIcon />
      <a
        href={`${process.env.PERSONA_HOSTNAME}/dashboard/contact-us`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Submit a request
      </a>
    </NavigationLeftHelpRow>
  )
}

const NavigationLeftHelpRow = styled.div`
  ${Typography.TextMedium};
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: ${Spacing[2]};
  margin-bottom: ${Spacing[2]};

  a {
    color: ${Color.TextPrimary};
    text-decoration: none;
  }
`

export default NavigationLeftHelp
